var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.625,
    height: 50,
    viewBox: "0 0 65.625 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone",
    transform: "translate(-3 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M30.656,56.438a7.843,7.843,0,0,1-1.875-.312l-8.906-2.812A6.336,6.336,0,0,1,15.656,45.5l3.281-10.469a6.176,6.176,0,0,1,3.125-3.75,6.11,6.11,0,0,1,4.688-.469l8.906,2.813a6.336,6.336,0,0,1,4.219,7.813L36.594,51.906A6.143,6.143,0,0,1,30.656,56.438ZM25.031,33.781a4.562,4.562,0,0,0-1.406.313,3.131,3.131,0,0,0-1.563,1.875L18.781,46.438a3.066,3.066,0,0,0,.156,2.344,3.131,3.131,0,0,0,1.875,1.563l8.906,2.813a3.161,3.161,0,0,0,3.906-2.031h0l3.281-10.469a3.066,3.066,0,0,0-.156-2.344,3.131,3.131,0,0,0-1.875-1.562l-8.906-2.812C25.656,33.938,25.344,33.781,25.031,33.781ZM3,25.188H7.688V40.813H3ZM63.938,8h4.688V58H63.938Z",
    fill: "#b0bec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M6,25.557V39L62.3,55.257V9.3Z",
    transform: "translate(1.665 0.721)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M8,26.46v3.421l50.076-7.93V12Z",
    transform: "translate(2.774 2.22)",
    fill: "#ff8a80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.d09460bf762968df00e3668e88e5db39.svg";
export { ForwardRef as ReactComponent };